import { defineMessages } from "react-intl";

const messages = defineMessages({
    color: {
        id: "tasks.barSorting.color",
    },
});

export default messages;
